<template>
    <StepShell :embedded="embedded" width="wide">
        <StepHeader :embedded="embedded" align="center" size="display" :title="t('onboarding.calendarFirst.contextRingsStep.title')">
            {{ t("onboarding.calendarFirst.contextRingsStep.body") }}
        </StepHeader>

        <ContextPanel :dimensions="context.dimensions" :percent="context.percent" :size="embedded ? 196 : 260" />

        <StepActions flush>
            <template #start>
                <p class="reassurance">
                    <i aria-hidden="true" class="bi bi-lock"></i>
                    {{ t("onboarding.calendarFirst.contextRingsStep.reassurance") }}
                </p>
            </template>
            <BaseButton theme="primary" @click="emit('continue')">
                {{ embedded ? t("onboarding.calendarFirst.actions.continue") : t("onboarding.calendarFirst.contextRingsStep.getStarted") }}
                <i aria-hidden="true" class="bi bi-arrow-right"></i>
            </BaseButton>
        </StepActions>
    </StepShell>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import ContextPanel from "~vue/ProfileSetup/ContextPanel.vue";
import type { ContextSnapshot } from "~vue/ProfileSetup/types";
import { useI18n } from "vue-i18n";

import StepActions from "./StepActions.vue";
import StepHeader from "./StepHeader.vue";
import StepShell from "./StepShell.vue";

/*
 * Use server scoring exclusively. Client defaults previously became stale immediately after users answered
 * the preceding screen.
 */
const { embedded = false } = defineProps<{ context: ContextSnapshot; embedded?: boolean }>();

const emit = defineEmits<{ continue: [] }>();
const { t } = useI18n();
</script>

<style scoped>
@reference "../../../css/tailwind.css";
@layer components {
    .reassurance {
        @apply details flex items-center gap-2 text-ink-muted;
    }
}
</style>
